import FilterForm from "../../../component/FilterForm/FilterForm";
import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import {InputLabelProps} from "../../../utils/InputLabelProps";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Switch} from "@mui/material";
import InputMask from "react-input-mask";
import {validateCpf} from "../../../utils/validateCpf";
import {validateCnpj} from "../../../utils/validateCnpj";
import Select from "react-select";
import {statusList, typeList} from "./lists";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../utils/handleChangeData";


export default function FilterRecebivelRural({filter, setFilter, setLoadData, setPage}) {

    const [lgShow, setLgShow] = useState(false);

    const [nomeParticipante, setNomeParticipante] = useState('');
    const [documentoParticipante, setDocumentoParticipante] = useState('');
    const [inicioVencimento, setInicioVencimento] = useState('');
    const [fimVencimento, setFimVencimento] = useState('')
    const [tipo, setTipo] = useState('')
    const [status, setStatus] = useState('');

    const [isCnpj, setIsCnpj] = useState(false)
    const toggleSwitch = () => {
        setIsCnpj(prevState => !prevState)
        setDocumentoParticipante('')
    }

    const handlesSubmit = (e) => {

        e.preventDefault();

        setFilter({
            ...(nomeParticipante && {nomeParticipante: nomeParticipante.trim()}),
            ...(documentoParticipante && {documentoParticipante: documentoParticipante.trim()}),
            ...(inicioVencimento && {inicioVencimento}),
            ...(fimVencimento && {fimVencimento}),
            ...(tipo && {tipo}),
            ...(status && {status})
        });

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const clearFilter = () => {
        setNomeParticipante('')
        setDocumentoParticipante('')
        setInicioVencimento('')
        setFimVencimento('')
        setTipo('')
        setStatus('')
        setFilter({});

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 0}
        >


            <TextField
                label="Nome do Participante"
                value={nomeParticipante}
                inputProps={{
                    maxLength: 100,
                }}
                onChange={(e) => setNomeParticipante(e.target.value)}
                fullWidth
                InputLabelProps={{
                    style: {
                        zIndex: 0,
                    },
                }}
            />

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {/*<div style={{marginRight: '10px'}}>*/}
                <Typography variant="body1">
                    <b>Documento: &nbsp;</b>
                </Typography>
                <Typography variant="body1">
                    CPF
                </Typography>
                <Switch
                    checked={isCnpj}
                    onChange={toggleSwitch}
                    color="primary"
                    inputProps={{'aria-label': 'alternar entre CNPJ e CPF'}}
                />
                <Typography variant="body1">
                    CNPJ
                </Typography>
            </div>

            {!isCnpj ?
                <InputMask mask="999.999.999-99" value={documentoParticipante} maskChar={null}
                           onChange={(e) => setDocumentoParticipante(e.target.value.trim())}>
                    {() =>
                        <TextField
                            label="CPF de um participante" variant="outlined"
                            error={documentoParticipante.length === 14 && !validateCpf(documentoParticipante)}
                            helperText={documentoParticipante.length === 14 && !validateCpf(documentoParticipante) ? 'CPF inválido' : ''}
                            inputProps={{
                                maxLength: 14,
                                minLength: 14,
                            }}
                            fullWidth
                            InputLabelProps={InputLabelProps}
                        />}
                </InputMask> :
                <InputMask mask="99.999.999/9999-99" value={documentoParticipante} maskChar={null}
                           onChange={(e) => setDocumentoParticipante(e.target.value.trim())}>
                    {() =>
                        <TextField
                            label="CNPJ de um participante" variant="outlined"
                            error={documentoParticipante.length === 18 && !validateCnpj(documentoParticipante)}
                            helperText={documentoParticipante.length === 18 && !validateCnpj(documentoParticipante) ? 'CNPJ inválido' : ''}
                            inputProps={{
                                maxLength: 18,
                                minLength: 18,
                            }}
                            fullWidth
                            InputLabelProps={InputLabelProps}
                        />}
                </InputMask>
            }

            <Box mb={1} pb={0.5}>
                Vencimento
            </Box>

            <DatePicker
                label="A partir de"
                sx={{
                    width: '49%',
                    marginRight: '2%',
                    zIndex: 0
                }}
                defaultValue={inicioVencimento ? dayjs(inicioVencimento) : null}
                onChange={(e) => handleChangeData(e, setInicioVencimento)}
                InputLabelProps={InputLabelProps}
            />
            <DatePicker
                label="Até"
                sx={{
                    width: '49%',
                    zIndex: 0
                }}
                defaultValue={fimVencimento ? dayjs(fimVencimento) : null}
                onChange={(e) => handleChangeData(e, setFimVencimento)}
                InputLabelProps={InputLabelProps}
            />

            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={typeList}
                defaultValue={typeList.find(item => item.value === tipo)}
                onChange={(e) => setTipo(e?.value)}
                placeholder='Tipo'
            />


            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={statusList}
                defaultValue={statusList.find(item => item.value === status)}
                onChange={(e) => setStatus(e?.value)}
                placeholder='Status'
            />

        </FilterForm>
    </>
}